import { render, staticRenderFns } from "./RepeatTypeSelect.vue?vue&type=template&id=28932a58&scoped=true&"
import script from "./RepeatTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./RepeatTypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./RepeatTypeSelect.vue?vue&type=style&index=0&id=28932a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28932a58",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
